import { cn } from "@/lib/utils";
import type { CSSProperties } from "react";

interface InlineSvgProps {
  content: string;
  className?: string;
  title?: string;
  role?: string;
  ariaLabel?: string;
  size?: number | string;
}

// Renders raw SVG markup inline so it can inherit CSS color via `currentColor`.
export function InlineSvg({
  content,
  className,
  title,
  role = "img",
  ariaLabel,
  size,
}: InlineSvgProps) {
  const inlineStyle: CSSProperties | undefined =
    size != null
      ? ({
          ["--inline-svg-size"]: typeof size === "number" ? `${size}px` : String(size),
        } as CSSProperties)
      : undefined;

  return (
    <span
      className={cn(
        "inline-block leading-none",
        size != null ? "[&_svg]:h-[var(--inline-svg-size)] [&_svg]:w-[var(--inline-svg-size)]" : "",
        className,
      )}
      role={role}
      aria-label={ariaLabel || title}
      style={inlineStyle}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
}
